import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7c947318")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createBlock(_component_Checkbox, {
    id: _ctx.name,
    modelValue: _ctx.selected,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selected = $event)),
    binary: true,
    class: "p-m-1"
  }, null, 8, ["id", "modelValue"]))
})